<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-1">Ghost Hunter’s Guide</p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-1">to</span> <span class="char-style-override-2">Portland</span> <span class="char-style-override-1">and the</span></p>
<p class="Basic-Paragraph para-style-override-3"><span class="char-style-override-2">Oregon Coast</span></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-4"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"><a id="x.3219"></a></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<div class="frame-2">
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2e4fd203